import React from 'react';
import SimpleTag from '@atlaskit/tag/simple-tag';
import { useIntl } from '@atlassian/jira-intl';
import type { ListViewControllerData } from '../../../../controllers/list-view-issues/types';
import messages from './messages';

export const SprintItem = ({ data }: { data: ListViewControllerData }) => {
	const { formatMessage } = useIntl();
	const { sprint } = data;

	let text;
	if (!sprint) {
		text = formatMessage(messages.backlog);
	} else if (sprint.state === 'CLOSED') {
		text = formatMessage(messages.completedSprint);
	} else {
		text = sprint.name;
	}

	return (
		<SimpleTag text={text} testId="business-list.ui.list-view.group-item.sprint-item.simple-tag" />
	);
};
